export default class StockClotureMoisPopupController {
	static $inject = ['$scope', '$stateParams', 'StocksCloturesService', 'notification', 'ModalService', '$uibModal', 'moment'];

	constructor($scope, $stateParams, StocksCloturesService, notification, ModalService, $uibModal, moment) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.StocksCloturesService = StocksCloturesService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.groupeSiteSelected = null;
		this.periode = null;
		this.date = undefined;
		this.derniereClotureMessage = '';
		this.isCloture = false;
		this.loading = false;
	}

	async $onInit() {
		this.isCloture = false;
		let groupeSites = await this.StocksCloturesService.getRegroupementSites(null);
		if (groupeSites.length == 1) {
			this.groupeSiteSelected = {
				id: groupeSites[0].id,
				libelle: groupeSites[0].libelle,
				code: groupeSites[0].code
			};
		}

		this.$scope.$watch(
			() => this.date,
			() => {
				this.verifieCloture();
			}
		);
		this.$scope.$watch(
			() => this.groupeSiteSelected,
			() => {
				this.getPeriode();
				this.verifieCloture();
			}
		);
	}
	async loadGroupeSites(valeur) {
		let groupeSites = await this.StocksCloturesService.getRegroupementSites(valeur);
		return groupeSites;
	}

	async getPeriode() {
		try {
			let groupeSiteId = this.groupeSiteSelected ? this.groupeSiteSelected.id : null;
			if (groupeSiteId) {
				this.periode = await this.StocksCloturesService.getPeriodeEnCoursCloture(groupeSiteId);
				this.date = this.periode.date;
			} else {
				this.periode = undefined;
				this.date = undefined;
			}
			await this.getDerniereCloture();
		} catch (ex) {
			this.notification.error(ex.data);
			this.periode = undefined;
			this.date = undefined;
			return false;
		}
	}

	async cloturer() {
		this.startLoading();
		try {
			let groupeSiteId = this.groupeSiteSelected ? this.groupeSiteSelected.id : null;
			if (groupeSiteId && this.periode && this.periode.date) {
				await this.StocksCloturesService.getFormulesExpirees(groupeSiteId, this.periode.date, true);
				//L'exécution peut être bloquée par la modale de 'getFormulesExpirees'
				await this.StocksCloturesService.clotureMensuelle(groupeSiteId, this.periode.date);
				this.notification.success('STOCKS_CLOTURES.CLOTURE_MOIS_EFFECTUEE');
			}
		} catch (ex) {
			this.ModalService.info({ modalTitle: 'Clôture impossible', modalMsg: ex.data, headerClass: 'modal-info' });
			return false;
		} finally {
			this.periode = undefined;
			await this.getPeriode();
			await this.verifieCloture();
			this.stopLoading();
		}
	}

	async decloturer() {
		try {
			this.startLoading();
			let groupeSiteId = this.groupeSiteSelected ? this.groupeSiteSelected.id : null;
			if (groupeSiteId && this.date) {
				await this.StocksCloturesService.decloturerMois(groupeSiteId, this.date);
				this.notification.success('STOCKS_CLOTURES.DECLOTURE_MOIS_EFFECTUEE');
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.periode = undefined;
			await this.getPeriode();
			await this.verifieCloture();
			this.stopLoading();
		}
	}

	async verifieCloture() {
		if (this.date && this.date.indexOf('/') > -1) {
			this.isCloture = false;
			try {
				let groupeSiteId = this.groupeSiteSelected ? this.groupeSiteSelected.id : null;
				if (groupeSiteId && this.date) {
					let cloture = await this.StocksCloturesService.estClotureMois(groupeSiteId, this.date);
					this.isCloture = cloture.isCloture;
					if (this.isCloture) {
						this.derniereClotureMessage = await this.StocksCloturesService.getClotureMois(groupeSiteId, this.date);
					} else this.getDerniereCloture();
				} else this.getDerniereCloture();
			} catch (ex) {
				this.notification.error(ex.data);
			}
		}
	}

	async getDerniereCloture() {
		if (!this.isCloture) {
			let groupeSiteId = this.groupeSiteSelected ? this.groupeSiteSelected.id : null;
			if (groupeSiteId) {
				this.derniereClotureMessage = await this.StocksCloturesService.getDerniereClotureMois(groupeSiteId);
			}
		}
	}

	hasDateError() {
		if (!this.date) {
			return true;
		}
		if (!this.periode.dateCloture) {
			return false;
		}
		const derniereClotureMoment = this.moment(this.periode.dateCloture, 'DD/MM/YYYY');
		const dateNouvelleCloture = this.moment(this.date, 'DD/MM/YYYY');
		return derniereClotureMoment.isAfter(dateNouvelleCloture);
	}

	annuler() {
		this.modalInstance.close();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
